<div class="picture-card">
  <div [dragula]="'picture-card-bag'"
       [dragulaModel]="cards">
    <div class="row card-row"
         *ngFor="let card of cards; let i = index">

      <div class="col-sm-9 d-flex flex-wrap">
        <div class="mb-5">
          <hr>
          <label for="pictureCardBody">Card Body
          </label>
          <span class="text-counter float-right"
                [innerHTML]="displayCount(card.body)"></span>
          <input class="full-width"
                 pInputText
                 maxlength="40"
                 id="pictureCardBody"
                 [(ngModel)]="card.body" />
        </div>
      </div>
      <div class="col-sm-3 mt-5">
        <span class="sm-padding-top ml-5">
          <i class="fa fa-times fa-col removeUrl"
             (click)="removeCard(i)"
             aria-hidden="true"></i>
        </span>
      </div>
      <div class="col-md-12">
        <div class="mb-5">
          <label for="pictureCardImageUrl">Image URL</label>
          <input class="full-width"
                 pInputText
                 id="pictureCardBImageUrl"
                 [(ngModel)]="card.imageUrl" />
        </div>
        <div class="col-md-2 d-flex align-items-center justify-content-center">
          <img class="img-responsive icon-image"
               src={{card.imageUrl}}
               alt={{card.body}} />
        </div>
      </div>
      <div class="col-md-12">
        <div class="mb-5 mt-3">
          <label for="pictureCardUrl">Card URL</label>
          <input class="full-width"
                 pInputText
                 id="pictureCardUrl"
                 [(ngModel)]="card.url" />
        </div>
      </div>
    </div>
    <div class="my-3">
      <button (click)="addCard()"
              class="btn btn-secondary">
        Add card
      </button>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/ng2/app/components/picture-card/picture-card.component.html